import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';


export const ConfirmDialog = ({ title, confirmLabel, cancelLabel, children, open, setOpen, onConfirm, onCancel = null }) => {
    const cancel = e => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(false);
        onCancel && onCancel();
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="confirm-dialog">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {cancelLabel && (
                    <Button
                        variant="contained"
                        onClick={cancel}
                        color="secondary"
                    >
                        {cancelLabel}
                    </Button>
                )}
                {confirmLabel && (
                    <Button
                        variant="contained"
                        onClick={() => {
                            setOpen(false);
                            onConfirm();
                        }}
                        color="default"
                    >
                        {confirmLabel}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
